import React, { useState } from "react";
import { Button, Modal } from "antd";
import { ContactUs } from "../../../../../assets/icons";
import { ANNUAL_BILLING_NOTE, formatPrice, getPlanPrice } from "../../planPricing";
import { AccountLevel } from "../../accountLevel";
import { isBilledYearly } from "../../registrationSession";

/** A limit of 0 is the API's way of saying the plan doesn't cap it. */
const asLimit = (limit) => limit || "Unlimited";

// The billing period comes from whoever is showing the plan, so this modal and
// the card it opens from always quote the same one. Read out of storage only
// when nobody passes it: before, this read storage alone, which the toggle on
// the page above had not necessarily been written to yet.
//
// `chooseButton` takes the Enterprise card's "Choose this plan" place, where a
// page asks for Enterprise itself (the Subscription page on the new flow).
function PlanDetail({
   planData,
   enterprice,
   accountLevel,
   isYearly = isBilledYearly(),
   chooseButton
}) {
   const [open, setOpen] = useState(false);
   return (
      <>
         <div className="plan-details-modal">
            <a onClick={() => setOpen(true)}>
               <span
                  style={{
                     color: "#F58F45",
                     fontFamily: "Poppins",
                     fontSize: "14px",
                     fontWeight: "500"
                  }}
               >
                  See full plan details
               </span>
            </a>
            <Modal
               open={open}
               onOk={() => setOpen(false)}
               onCancel={() => setOpen(false)}
               width={900}
            >
               {enterprice ? (
                  <>
                     <div className="enterprice-modal">
                        <h2>Contact us for a Custom Plan</h2>
                        <img src={ContactUs} />
                        <p>
                           Our Enterprise plan is designed to meet your specific needs. Contact us
                           to discuss your requirements and receive a customized offer.
                        </p>
                        <p>
                           Reach out at{" "}
                           <a href="mailto:info@kaptechgroup.com" target="_blank">
                              info@kaptechgroup.com
                           </a>
                        </p>
                        <div className="closeModal">
                           <Button
                              color="primary"
                              variant="outlined"
                              size="large"
                              onClick={() => setOpen(false)}
                           >
                              Close
                           </Button>
                        </div>
                     </div>
                  </>
               ) : (
                  <>
                     <h2>{planData?.name}</h2>
                     <p>This plan includes:</p>
                     <ul>
                        {/* The seats and the storage are an organization's
                            measure of a plan. A business account is told what
                            it can do instead, the same as on its card — see
                            pages/auth/register/accountLevel.js. */}
                        {accountLevel === AccountLevel.Business ? (
                           <li>
                              With {asLimit(planData?.workspaceLimit)} workspaces and{" "}
                              {asLimit(planData?.projectDashboardLimit)} project dashboards, collect
                              and analyse the feedback your customers leave you
                           </li>
                        ) : (
                           <li>
                              With {asLimit(planData?.workspaceLimit)} workspaces and{" "}
                              {asLimit(planData?.membersLimit)} users per workspace, enjoy{" "}
                              {planData?.databaseLimit ? (
                                 <>a data storage limit of {planData.databaseLimit}GB</>
                              ) : (
                                 <>an unlimited storage</>
                              )}
                           </li>
                        )}
                     </ul>
                     <p>{planData?.description}</p>
                     <div className="plan-price">
                        <p>Plan's Price</p>
                        <h4>
                           <span>USD </span>
                           {formatPrice(getPlanPrice(planData, isYearly))}/mo.
                        </h4>
                        {isYearly && <p>{ANNUAL_BILLING_NOTE}</p>}
                     </div>
                  </>
               )}
            </Modal>
         </div>
         {enterprice &&
            (chooseButton ?? (
               <Button onClick={() => setOpen(true)} type="default" className={`defaultButton`}>
                  Choose this plan
               </Button>
            ))}
      </>
   );
}

export { PlanDetail };
